import Vue from "vue";
import { Component } from "vue-property-decorator";
import { validations, validationMessages } from "./validations";
import * as icons from "@/components/icons";
import {
    IAffiliate,
} from "@/models";
import { Validation } from "vuelidate";

@Component({
    name: "affiliates",
    validations,
    components: {
        "add-icon": icons.AddIcon,
        "edit-icon": icons.EditIcon,
        "save-icon": icons.SaveIcon,
        "delete-icon": icons.DeleteIcon,
    },
})

export default class Affiliates extends Vue {
    public loadPromises: Array<Promise<any>>;
    public affiliateId: number;
    public affiliateSearch: string;
    public affiliateName: string;
    public editingAffiliateId: number;
    public editingAffiliateName: string;

    constructor() {
        super();

        this.loadPromises = [];
        this.affiliateId = null;
        this.affiliateSearch = "";
        this.affiliateName = "";
        this.editingAffiliateId = 0;
        this.editingAffiliateName = "";

        if (!this.$store.state.request.isReferenceDataLoaded) {
            this.loadPromises.push(this.$store.dispatch("request/fetchReferenceData"));
        }
    }

    public get validationMessages(): { [key: string]: string } {
        return validationMessages;
    }

    public async addAffiliate(): Promise<void> {
        if (this.validateBeforeSave(this.$v.affiliateName)) {
            await this.$store.dispatch("request/addAffiliate", {
                Name: this.affiliateName,
            });
            this.affiliateName = "";
            this.$v.affiliateName.$reset();
        }
    }

    public async editAffiliate(affiliate: IAffiliate): Promise<void> {
        this.editingAffiliateId = affiliate?.affiliateId ?? 0;
        this.editingAffiliateName = affiliate?.name ?? "";
    }

    public async saveEditAffiliate(affiliate: IAffiliate): Promise<void> {
        if (this.validateBeforeSave(this.$v.editingAffiliateName)) {
            this.editingAffiliateId = 0;
            affiliate.name = this.editingAffiliateName;
            await this.$store.dispatch("request/saveEditAffiliate", affiliate);
            this.editingAffiliateName = "";
            this.$v.editingAffiliateName.$reset();
        }
    }

    public async deleteAffiliate(affiliateId: number): Promise<void> {
        await this.$store.dispatch("request/deleteAffiliate", affiliateId);
    }

    public get affiliates(): IAffiliate[] {
        return this.$store.getters["request/getFilteredAffiliates"](this.affiliateSearch);
    }

    public validateBeforeSave(rules: Validation): boolean {
        rules.$touch();
        return !rules.$invalid;
    }
}
